import io from "socket.io-client";

let socketIO;

export default {
    createConnection: function() {
        // start socket.io server and cache io value
        // socketIO = io.connect("http://localhost:8797");
        socketIO = io.connect("https://api.gauuniform.vn");

        if (!socketIO) {
            throw new Error("must call .createConnection(server) before you can call .getio()");
        }
        return socketIO;
    },

    getIO: function() {
        // return previously cached value
        if (!socketIO) {
            throw new Error("must call .createConnection(server) before you can call .getio()");
        }

        return socketIO;
    }
}